export enum TrackingTaskType {
  Todo = 'task',
  Habit = 'habit',
  Repeating = 'repeating_task',
}
